import { EventTypes } from '../../../types/event.types';
import type { CitationsDocumentImportCompletedPayload, SystemJobStatusChangedPayload } from '../../../types/event.types';
import type { CitationDocumentModel } from '../../../types/citationsDocument.types';
import type { EventHandlerMap } from '../../../libs/events/eventHandler';

export const sourcesEventHandlers: EventHandlerMap = {
    [EventTypes.SystemJobStatusChanged]: (event, queryClient) => {
        const payload = event.payload as SystemJobStatusChangedPayload;
        queryClient.setQueriesData<CitationDocumentModel[]>(
            { queryKey: ['reviews', 'citations'] },
            (old) => old?.map(doc => doc.job?.id === payload.jobId
                ? { ...doc, job: { id: payload.jobId, status: payload.status } }
                : doc)
        );
    },
    [EventTypes.CitationsDocumentImportCompleted]: (event, queryClient) => {
        const payload = event.payload as CitationsDocumentImportCompletedPayload;
        queryClient.setQueriesData<CitationDocumentModel[]>(
            { queryKey: ['reviews', 'citations'] },
            (old) => old?.map(doc => doc.id === payload.documentId
                ? { ...doc, recordCount: payload.recordCount }
                : doc)
        );
    },
    [EventTypes.CitationsDocumentAdded]: (event, queryClient, originId) => {
        if (event.originId !== originId) {
            queryClient.invalidateQueries({ queryKey: ['reviews', 'citations', event.scopeId] });
        }
    },
};
